import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import TryLogin from "../Components/TryLogin";
import UserContext from "../UserContext";
import Logged from "../Components/Profile.jsx";
import { fetchChatsWithMessages, loadUserProfile } from "../utils/functions";
import ChatComponent from "../Components/Messages/ChatComponent";
import DisplayChatComponent from "../Components/Messages/DisplayChatComponent";
import SEO from "../Components/SEO";

function MessagesPage() {
  const { user } = React.useContext(UserContext);
  const [loading, setloading] = React.useState(true);
  const [chats, setchats] = React.useState([]);
  const [selected, setselected] = React.useState({});
  const [load, setload] = React.useState(false);
  const [chatHistory, setchatHistory] = React.useState([]);
  const [preloadedMessages, setpreloadedMessages] = React.useState([]);

  const toggleLoad = () => {
    setload(!load);
  };

  const changeSelected = (chat, temppreloadedMessages = []) => {
    sessionStorage.setItem("selected", JSON.stringify(chat));
    setpreloadedMessages(temppreloadedMessages);
    if (chatHistory[chatHistory.length - 1]?._id !== chat._id) {
      setchatHistory([
        ...chatHistory,
        { chat, messages: temppreloadedMessages },
      ]);
    } else {
      setchatHistory(
        chatHistory.map((item) => {
          return item.chat._id === chat._id
            ? { chat, messages: temppreloadedMessages }
            : item;
        })
      );
    }
    setselected(chat);
    toggleLoad();
  };

  const goBack = () => {
    if (chatHistory.length < 2) {
      setchatHistory([]);
      setselected({});
      return;
    }
    setselected(chatHistory[chatHistory.length - 2]?.chat);
    sessionStorage.setItem(
      "selected",
      JSON.stringify(chatHistory[chatHistory.length - 2]?.chat)
    );
    setpreloadedMessages(chatHistory[chatHistory.length - 2]?.messages || []);
    setchatHistory(
      chatHistory.filter((_item, index) => index !== chatHistory.length - 1)
    );
  };

  const history = useHistory();
  if (!user.token) {
    history.push("/login");
  }

  React.useEffect(() => {
    async function loadChats() {
      setloading(true);
      setchats(await fetchChatsWithMessages(user.token));
      setloading(false);
    }
    loadChats();
  }, [user, load]);

  const searchUser = async (userId) => {
    let searchedUser = await loadUserProfile(userId, user.token);
    if (searchedUser._id) {
      changeSelected(searchedUser);
    }
  };

  const location = useLocation();

  React.useEffect(() => {
    let search = location.search;
    if (search) {
      search = search.slice(1);
      let values = search.split("&");
      for (let i = 0; i < values.length; i++) {
        if (values[i].split("=")[0] === "user") {
          searchUser(values[i].split("=")[1]);
          break;
        }
      }
    }
    // eslint-disable-next-line
  }, [location, user]);

  return (
    <>
      <SEO title={`Messages`} description="Messages Panel"></SEO>
      <div className="sm:px-2 lg:px-60 mb-10 pb-12 lg:pb-0">
        <div className="">
          <div className="px-2 lg:px-0 lg:flex w-full gap-10">
            <div
              className={
                selected?._id ? "lg:w-1/2 hidden lg:block" : "lg:w-1/2"
              }
            >
              <ChatComponent
                chats={chats}
                changeSelected={changeSelected}
                load={load}
                loading={loading}
                selected={selected}
              ></ChatComponent>
            </div>
            <div className="lg:w-1/2">
              {selected?._id ? (
                <DisplayChatComponent
                  selected={selected}
                  load={load}
                  toggleLoad={toggleLoad}
                  goBack={goBack}
                  preloadedMessages={preloadedMessages}
                ></DisplayChatComponent>
              ) : user.token ? (
                <Logged />
              ) : (
                <TryLogin />
              )}
            </div>

            <div className={selected._id ? "lg:w-1/2 lg:hidden" : "hidden"}>
              {user.token ? <Logged /> : <TryLogin />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MessagesPage;
